import { render, staticRenderFns } from "./LoginView.vue?vue&type=template&id=5c6101e4&scoped=true"
import script from "./LoginView.vue?vue&type=script&lang=js"
export * from "./LoginView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6101e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/_work/studio-admin/studio-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c6101e4')) {
      api.createRecord('5c6101e4', component.options)
    } else {
      api.reload('5c6101e4', component.options)
    }
    module.hot.accept("./LoginView.vue?vue&type=template&id=5c6101e4&scoped=true", function () {
      api.rerender('5c6101e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/LoginView.vue"
export default component.exports